
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.697 4.384a.73.73 0 011.03 0l9.576 9.576a.73.73 0 11-1.03 1.031L4.696 5.416a.73.73 0 010-1.032z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.697 14.991a.73.73 0 010-1.03l9.575-9.576a.73.73 0 111.031 1.03l-9.575 9.576a.73.73 0 01-1.031 0z","fill":"currentColor"}})])
          )
        }
      }
    